import React from 'react'
import { SvgIcon as Icon } from '@material-ui/core'

const DownloadIcon = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        d="M15.6 9.06683L9 15.6668L2.4 9.06683L3.58333 7.89183L8.16666 12.4752V0.666828H9.83333L9.83333 12.4752L14.4167 7.8835L15.6 9.06683ZM9 15.6668H0.666664L0.666664 17.3335H17.3333V15.6668L9 15.6668Z"
        fill="#0071DB"
      />
    </Icon>
  )
}

export default DownloadIcon
